import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Program } from '../../Reports/NewReportDialog';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import ProgramColumn, { ProgramColumnProps } from './ProgramColumn';
import ReportColumn, { ReportColumnProps } from './ReportColumn';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { thinScrollbarStyles } from 'shared/design-system/settings/variables/Scrollbar';

export interface ProgramModalContentProps
  extends Omit<ProgramColumnProps, 'program' | 'programList'>,
    Omit<ReportColumnProps, 'program' | 'programsList'> {
  isActive: boolean;
  programId?: number;
  programsList: RequestState<{
    allPrograms: Program[];
  }>;
}

export const StyledProgramModalDiv = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  .left-modal-column {
    width: 349px;
    height: 100%;
    background-color: ${COLORS.grayLight};
    padding: ${SPACERS.extraLarge} ${SPACERS.medium} 0 ${SPACERS.extraLarge};
  }
  .right-modal-column {
    flex: 1;
    overflow: auto;
    ${thinScrollbarStyles}
  }
`;

const flexStyle = { flex: 1 };
const ProgramModalContent: React.FC<ProgramModalContentProps> = ({
  allNPOUsers,
  programId,
  programName,
  programsList,
  onClose,
  reloadProgramList,
}) => {
  const program = useMemo(
    () =>
      programsList.type === 'REQUEST_SUCCESS'
        ? programsList.data.allPrograms.find(x =>
            programId !== undefined
              ? x.Id === programId
              : x.name === programName,
          )
        : undefined,
    [programsList, programId, programName],
  );

  return (
    <StyledProgramModalDiv>
      <div className="left-modal-column">
        {program && programsList.data?.allPrograms ? (
          <ProgramColumn
            program={program}
            allNPOUsers={allNPOUsers}
            programName={programName}
            programList={programsList.data.allPrograms}
            reloadProgramList={reloadProgramList}
          />
        ) : (
          <TrueImpactLoading />
        )}
      </div>
      {program && programsList.data?.allPrograms ? (
        <ReportColumn
          program={program}
          programsList={programsList}
          programName={programName}
          onClose={onClose}
          reloadProgramList={reloadProgramList}
        />
      ) : (
        <div style={flexStyle}>
          <TrueImpactLoading />
        </div>
      )}
    </StyledProgramModalDiv>
  );
};

export default ProgramModalContent;
